<template>
  <div class="main" id="scene">
    <div class="main_bg">
      <div class="banner">
        <img id="bannerBg" src="https://www.csvw.com/u/cms/www/202601/12113113gVQb.jpg" style="width: 100%" />
<!--        <div class="wenben">-->
<!--          <div class="textWrapper">-->
<!--            <div>-->
<!--              四十载风云激荡，时代浪潮奔涌向前。站在新的历史坐标上回望，上汽大众的发展历程不仅是中国汽车工业现代化的生动缩影，更是中德合作持续深化、绿色创新不断突破、企业责任日益延伸的厚重见证。面对全球碳中和稳步推进的时代背景，上汽大众始终将环境、社会与治理（ESG）理念深度融入发展战略，全面拥抱新能源转型，并致力于成为：“合资新阶段的探路者和引领者”、“长期主义坚守者”以及“值得信赖的出行方案提供者”。-->
<!--            </div>-->
<!--            <div class="en">-->
<!--              Four decades of dynamic change and relentless progress have defined our era. As we stand at this new historical juncture and look back, SAIC VOLKSWAGEN's journey stands not only as a vivid reflection of China's automotive modernization, but also as a profound testament to the sustained deepening of Sino-German cooperation, continuous breakthroughs in green innovation, and the expanding scope of corporate responsibility. Against the backdrop of a global push toward carbon neutrality, SAIC VOLKSWAGEN has deeply integrated Environmental, Social, and Governance (ESG) principles into its strategic development, fully embracing the transition to new energy, striving to become “A Pioneer & Leader in Joint Venture”, “A Practitioner of Long-termism” and “A Reliable Mobility Solutions Provider”.-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="group">-->
<!--            <img src="../../assets/image/esg/esg1.png" alt="">-->
<!--            <img src="../../assets/image/esg/esg2.png" alt="">-->
<!--            <img src="../../assets/image/esg/esg3.png" alt="">-->
<!--            <img src="../../assets/image/esg/esg4.png" alt="">-->
<!--            <img src="../../assets/image/esg/esg5.png" alt="">-->
<!--            <img src="../../assets/image/esg/esg6.png" alt="">-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <sceneMenuPc ref="sceneMenuPc"></sceneMenuPc>
      <scene1Pc id="scene1" @collapseChange="collapseChange"></scene1Pc>
      <scene2Pc id="scene2" @collapseChange="collapseChange"></scene2Pc>
      <scene3Pc id="scene3" @collapseChange="collapseChange"></scene3Pc>
      <scene4Pc id="scene4" @collapseChange="collapseChange"></scene4Pc>
      <scene5Pc id="scene5" @collapseChange="collapseChange"></scene5Pc>
      <sceneEndPc></sceneEndPc>
    </div>
  </div>
</template>

<script>
import config from "./config";
import scene1Pc from "./scene1Pc.vue";
import scene2Pc from "./scene2Pc.vue";
import scene3Pc from "./scene3Pc.vue";
import scene4Pc from "./scene4Pc.vue";
import scene5Pc from "./scene5Pc.vue";
import sceneEndPc from "./sceneEndPc.vue";
import sceneMenuPc from "./sceneMenuPc.vue";
export default {
  components: {
    sceneMenuPc,
    sceneEndPc,
    scene1Pc,
    scene2Pc,
    scene3Pc,
    scene4Pc,
    scene5Pc,
  },
  data() {
    return config;
  },
  beforeMount() { },
  mounted() {
    console.log(this);
    // console.log(7777,'scenePc mounted')
    // $('.newheader .oneul .lilv1:eq(2) > button > span').removeClass('active');
    // $('.newheader .oneul .lilv1:eq(1) > button > span').addClass('active');
    this.setWindowScale();
    window.addEventListener('resize', this.setWindowScale);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.setWindowScale);
  },
  methods: {
    setWindowScale() {
      const scaleMap = {
        1.5: '70%',
        1.25: '78%',
        1: '100%'
      };
      document.documentElement.style.zoom =
        scaleMap[window.devicePixelRatio] || '100%';
    },
    showPop(item) {
      this.showCover = true;
      this.showImg = item.imageurlbig;
    },
    closePop() {
      this.showCover = false;
    },
    collapseChange(){
      this.$refs.sceneMenuPc.onScroll()
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  min-width: 1200px;
  margin: 0px auto;
  font-size: 14px;
  font-family: FZYOUH_ZHONGXIJW;
}

.main_bg {
  width: 100%;
  min-width: 1200px;
  background: #ffffff;
}

/*.banner {*/
/*  background-image: url(../../assets/csr/imgs/bannerNoWords@2x.png);*/
/*  width: 100%;*/
/*  height: 100%;*/
/*}*/
.banner {
  position: relative;
}

.wenben {
  padding: 24px;
  position: absolute;
  bottom:40px;
  right: 10%;
  left: 10%;
  /*bottom: 0;*/
  /*top:20%;*/
  /*transform: scale(0.7);*/
  color: #fff;
  font-size: 14px;
  line-height: 1.5;
  background-color: rgba(0, 0, 0, 0.25);
  display: flex;justify-content: space-between;
  gap: 20px;
  .en{
    margin-top: 24px;
  }
  .textWrapper{
    flex:1
  }
  /* 添加这一行 */
  .group {
    display: flex;
    gap: 4px;
    width: 54%;
    /* 图片之间的间距 */

    img {
      flex: 1;
      /* 关键属性：使图片等宽平分容器 */
      width: 0;
      /* 配合flex:1实现等宽 */
      height: auto;
      /* 保持原始宽高比 */
      object-fit: contain;
      /* 保持图片完整显示 */
    }
  }
}
</style>
